import readReportCount from "./readReportCount";

const updateConversionRate = (
  viewsSelector,
  conversionsSelector,
  rateSelector,
  options = {}
) => {
  let checkCount = 0;
  const maxChecks = 60; // Stop checking after 30 seconds (60 * 500ms)
  // Only show comparison badge when explicitly comparing with previous time period (comparison_expected: true)
  const comparisonExpected = options.comparison_expected === true;

  let conversion_check = setInterval(function () {
    const viewsSpan = $(viewsSelector);
    const conversionsSpan = $(conversionsSelector);

    // Increment check count on every tick and enforce a maximum number of checks
    checkCount += 1;

    // If elements are missing, stop checking to avoid running the interval forever
    if (viewsSpan.length === 0 || conversionsSpan.length === 0) {
      clearInterval(conversion_check);
      return;
    }

    // Stop checking after maxChecks even if data-loading never flips to false
    if (checkCount >= maxChecks) {
      clearInterval(conversion_check);
      return;
    }
    if (viewsSpan.attr("data-loading") == "false" && conversionsSpan.attr("data-loading") == "false") {
      const views = readReportCount(viewsSpan);
      const conversions = readReportCount(conversionsSpan);

      let conversionRateValue =
        views && conversions && conversions > 0 ? (conversions / views) * 100 : 0;

      if (conversionRateValue > 100) {
        conversionRateValue = 100.0;
      }

      $(rateSelector).text(conversionRateValue.toFixed(2) + "%");

      // Handle comparison counts if available
      // Read comparison counts from data attributes set by ReportCount components
      const comparisonViews = viewsSpan.attr("data-comparison-count");
      const comparisonConversions = conversionsSpan.attr("data-comparison-count");
      const rateElement = $(rateSelector);
      
      // Check for existing badge in parent container (since we append to parent)
      const parentContainer = rateElement.parent();
      const existingBadge = parentContainer.length > 0 
        ? parentContainer.find(".conversion-rate-comparison-badge")
        : rateElement.siblings(".conversion-rate-comparison-badge");

      // Check if comparison payload exists by checking if attributes exist on elements
      // If attributes don't exist, there's no comparison payload
      const hasComparisonPayload = viewsSpan.is('[data-comparison-count]') || conversionsSpan.is('[data-comparison-count]');
      
      // Show placeholder badge immediately if comparison is expected but data not yet loaded
      // This prevents layout shift by reserving space from the start
      const hasComparisonData = comparisonViews !== undefined && comparisonViews !== null && comparisonViews !== "" &&
                                comparisonConversions !== undefined && comparisonConversions !== null && comparisonConversions !== "";
      
      if (comparisonExpected && hasComparisonPayload && existingBadge.length === 0 && !hasComparisonData) {
        const comparisonLabel =
          options.comparison_label || "vs last period";
        const badgeBelow = options.badge_below === true;
        const hideComparisonLabel = options.hide_comparison_label === true;
        const badgeTitleAttr = hideComparisonLabel ? "" : ` title="${comparisonLabel}"`;
        // No badge exists yet and comparison data isn't ready, show placeholder immediately
        const placeholderBadge = $(`
          ${
            badgeBelow
              ? `<div class="row hard-center"><span class="inline-flex items-center px-2 py-1 rounded text-base font-medium conversion-rate-comparison-badge conversion-rate-comparison-loading bg-gray-100 text-gray-800" style="min-width: 80px;"${badgeTitleAttr}><span class="cf-loading-spinner reports-spinner" style="width: 12px; height: 12px; margin-right: 4px;"></span></span></div>`
              : `<span class="inline-flex items-center px-2 py-1 ml-2 rounded text-base font-medium conversion-rate-comparison-badge conversion-rate-comparison-loading bg-gray-100 text-gray-800" style="min-width: 80px;"${badgeTitleAttr}><span class="cf-loading-spinner reports-spinner" style="width: 12px; height: 12px; margin-right: 4px;"></span></span>`
          }
        `);
        if (options.badgeContainer) {
          $(options.badgeContainer).append(placeholderBadge);
        } else {
          if (badgeBelow) {
            if (parentContainer.length > 0) {
              parentContainer.after(placeholderBadge);
            } else {
              rateElement.after(placeholderBadge);
            }
          } else {
            // Append to parent container (div.row.hard-center) to match ReportCount structure
            if (parentContainer.length > 0) {
              parentContainer.append(placeholderBadge);
            } else {
              rateElement.after(placeholderBadge);
            }
          }
        }
      }

      // If comparison data exists but comparison is not expected or payload doesn't exist, remove badges
      if (hasComparisonData && (!comparisonExpected || !hasComparisonPayload)) {
        const currentBadge = parentContainer.length > 0 
          ? parentContainer.find(".conversion-rate-comparison-badge")
          : rateElement.siblings(".conversion-rate-comparison-badge");
        if (currentBadge.length > 0) {
          currentBadge.remove();
        }
        clearInterval(conversion_check);
      }
      // If we have comparison data, process it (but only if comparison is expected and payload exists)
      else if (hasComparisonData && comparisonExpected && hasComparisonPayload) {
        clearInterval(conversion_check);

        const comparisonViewsNum = parseInt(comparisonViews, 10);
        const comparisonConversionsNum = parseInt(comparisonConversions, 10);

        // Check if we have valid numbers (not NaN)
        if (!isNaN(comparisonViewsNum) && !isNaN(comparisonConversionsNum)) {
          let comparisonRateValue = 0;
          if (comparisonViewsNum > 0 && comparisonConversionsNum >= 0) {
            comparisonRateValue = (comparisonConversionsNum / comparisonViewsNum) * 100;
          }

          if (comparisonRateValue > 100) {
            comparisonRateValue = 100.0;
          }

          // Calculate percentage change
          let percentageChange = null;
          if (comparisonRateValue !== 0) {
            percentageChange = ((conversionRateValue - comparisonRateValue) / comparisonRateValue) * 100;
          } else if (comparisonRateValue === 0 && conversionRateValue > 0) {
            percentageChange = 100;
          } else {
            percentageChange = 0;
          }

          // Remove existing badge (including placeholder)
          // Re-check for badge since it might have been added after initial check
          const currentBadge = parentContainer.length > 0 
            ? parentContainer.find(".conversion-rate-comparison-badge")
            : rateElement.siblings(".conversion-rate-comparison-badge");
          if (currentBadge.length > 0) {
            currentBadge.remove();
          }

          if (percentageChange !== null && !isNaN(percentageChange)) {
            const roundedChange = Math.round(percentageChange);
            const badgeClass = roundedChange > 0
              ? "bg-green-100 text-green-800"
              : roundedChange < 0
              ? "bg-red-100 text-red-800"
              : "bg-gray-100 text-gray-800";

            const arrowSvg = roundedChange > 0
              ? '<svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" style="transform: rotate(-45deg)"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>'
              : roundedChange < 0
              ? '<svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" style="transform: rotate(45deg)"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>'
              : "";

            const comparisonLabel =
              options.comparison_label || "vs last period";
            const badgeBelow = options.badge_below === true;
            const hideComparisonLabel = options.hide_comparison_label === true;
            const badgeTitleAttr = hideComparisonLabel ? "" : ` title="${comparisonLabel}"`;
            const labelSpan = hideComparisonLabel
              ? ""
              : `<span class="ml-1 conversion-rate-comparison-label" style="display: none;">${comparisonLabel}</span>`;
            const badge = $(`
              ${
                badgeBelow
                  ? `<div class="row hard-center"><span class="inline-flex items-center px-2 py-1 rounded text-base font-medium conversion-rate-comparison-badge ${badgeClass}"${badgeTitleAttr}>${arrowSvg}${Math.abs(roundedChange)}%${labelSpan}</span></div>`
                  : `<span class="inline-flex items-center px-2 py-1 ml-2 rounded text-base font-medium conversion-rate-comparison-badge ${badgeClass}"${badgeTitleAttr}>${arrowSvg}${Math.abs(roundedChange)}%${labelSpan}</span>`
              }
            `);

            badge
              .on("mouseenter", function () {
                $(this).find(".conversion-rate-comparison-label").css("display", "inline-block");
              })
              .on("mouseleave", function () {
                $(this).find(".conversion-rate-comparison-label").css("display", "none");
              });

            // Insert badge - append to parent container to match ReportCount structure
            if (options.badgeContainer) {
              $(options.badgeContainer).append(badge);
            } else {
              const parentContainer = rateElement.parent();
              if (badgeBelow) {
                if (parentContainer.length > 0) {
                  parentContainer.after(badge);
                } else {
                  rateElement.after(badge);
                }
              } else {
                if (parentContainer.length > 0) {
                  parentContainer.append(badge);
                } else {
                  rateElement.after(badge);
                }
              }
            }
          } else {
            // If no valid comparison, remove placeholder if it exists
            const currentBadge = parentContainer.length > 0 
              ? parentContainer.find(".conversion-rate-comparison-badge")
              : rateElement.siblings(".conversion-rate-comparison-badge");
            if (currentBadge.length > 0) {
              currentBadge.remove();
            }
          }
        } else {
          // Invalid comparison data, remove placeholder
          const currentBadge = parentContainer.length > 0 
            ? parentContainer.find(".conversion-rate-comparison-badge")
            : rateElement.siblings(".conversion-rate-comparison-badge");
          if (currentBadge.length > 0) {
            currentBadge.remove();
          }
        }
      } else if (!comparisonExpected || !hasComparisonPayload || checkCount >= maxChecks) {
        // No comparison expected, no comparison payload, or timeout reached, remove all badges and stop checking
        const currentBadge = parentContainer.length > 0 
          ? parentContainer.find(".conversion-rate-comparison-badge")
          : rateElement.siblings(".conversion-rate-comparison-badge");
        if (currentBadge.length > 0) {
          currentBadge.remove();
        }
        clearInterval(conversion_check);
      }
      
      checkCount++;
    }
  }, 500);
};

export default updateConversionRate;
